<template>
    <!-- 餐饮订单管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'mealOrder')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="日期选择">
                    <a-date-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['whichDay',{initialValue: moment()}]"
                    />
                </a-form-item>
                <a-form-item label="操作人">
                    <a-input placeholder="请输入" v-decorator="['operationWho']" ></a-input>
                </a-form-item>
                <a-form-item label="支付状态">
                    <a-select allowClear placeholder="请选择" mode="tags" v-decorator="['payState']">
                        <a-select-option v-for="(item, index) in $utils.payState" :value="index" :key="index">{{item}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="购买门店">
                    <a-select allowClear placeholder="请选择" v-decorator="['shopId']">
                        <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['account']" ></a-input>
                </a-form-item>
                <a-form-item label="餐饮订单号">
                    <a-input placeholder="请输入" v-decorator="['orderId']" ></a-input>
                </a-form-item>
                <a-form-item label="来源">
                    <a-select allowClear placeholder="请选择" v-decorator="['orderPlatform', {initialValue: '7'}]" disabled>
                        <a-select-option value="7">点餐小程序</a-select-option>
                        <a-select-option value="8">吧台</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="桌号">
                    <a-input placeholder="请输入" v-decorator="['deskNum']" ></a-input>
                </a-form-item>
                <a-form-item label="支付金额">
                    <a-input-group compact >
                        <a-input class="range-input range-input-left" placeholder="最小支付金额" v-decorator="['payAmountMin']" />
                        <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                        <a-input class="range-input range-input-right" placeholder="最大支付金额" v-decorator="['payAmountMax']" />
                    </a-input-group>
                </a-form-item>
                <a-form-item label="支付方式">
                    <a-select allowClear placeholder="请选择" v-decorator="['payMode', {initialValue: 2}]" >
                        <template v-for="(item,index) in $utils.payMode">
                            <a-select-option :key="index" :value="index" v-if="index > 0">{{item}}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item label="下单时间">
                    <a-range-picker
                        style="width:282px"
                        showTime
                        format="YYYY/MM/DD HH:mm"
                        v-decorator="['orderTime']"
                    />
                </a-form-item>
                <a-form-item label="支付时间">
                    <a-range-picker
                        style="width:282px"
                        showTime
                        format="YYYY/MM/DD HH:mm"
                        v-decorator="['payTime']"
                    />
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" :loading="searchLoading" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <div class="mb16 flex flex-space-between" v-if="getBtnByAuth('exportMeal')">
                <a-button type="primary" @click="exportExcel()" :loading="loading">导出excel</a-button>
                <div>
                    <span style="padding-right: 20px; font-size: 16px">当日收入金额: <span style="color: #ff6d33">{{MealAmountTotal.incomeAmount}}</span>元</span> 
                    <span style="padding-right: 20px; font-size: 16px">当日退款金额: <span style="color: #ff6d33">{{MealAmountTotal.refundAmount}}</span>元</span> 
                    <span style="padding-right: 20px; font-size: 16px">当日实际到账金额: <span style="color: #ff6d33">{{MealAmountTotal.amount}}</span>元</span> 
                </div>
            </div>
            <a-table :scroll="{x:800}" :loading="searchLoading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.orderId">
                <span slot="payAmount" slot-scope="payAmount">{{payAmount ? payAmount : "-"}}</span>
                <span slot="deskNum" slot-scope="deskNum">{{deskNum ? deskNum : "-"}}</span>
                <span slot="shopName" slot-scope="shopName">{{shopName ? shopName : "-"}}</span>
                <!-- <span slot="payAmount" slot-scope="payAmount">{{payAmount ? payAmount.replace('T',' ') : "-"}}</span> -->
                <span slot="refundAmount" slot-scope="refundAmount">{{refundAmount ? refundAmount : "-"}}</span>
                <span slot="orderTime" slot-scope="orderTime">{{orderTime ? orderTime.replace('T',' ') : "-"}}</span>
                <span slot="payTime" slot-scope="payTime">{{payTime ? payTime.replace('T',' ') : "-"}}</span>
                <span slot="refundTime" slot-scope="refundTime">{{refundTime ? refundTime.replace('T',' ') : "-"}}</span>
                
                <span slot="action" slot-scope="a, row">
                    <span v-if="getBtnByAuth('mealOrderDetail')">
                        <a class="text-primary" @click="mealDetail(row.orderId)">订单详情</a>
                        <a-divider type="vertical"/>
                    </span>

                    <span v-if="getBtnByAuth('mealOrderRefund')">
                        <a v-if="row.payState === 3 || row.payState === 6" class="text-primary" @click="mealRefund(row.orderId,row.payAmount)">退款</a>
                        <span v-else class="text-disabled">退款</span>
                    </span>
                </span>
            </a-table>
        </div>
            <a-modal title="餐饮订单详情" v-model="visible" :footer="null" @cancel="visible = false" :width="600">
                <a-row class="mb16">
                    <a-col :span="24">支付时间：{{detailData.payTime ? detailData.payTime.replace('T',' ') : ''}}</a-col>
                </a-row>
                <a-row class="mb16">
                    <a-col :span="12">桌号：{{detailData.deskNum}}</a-col>
                    <a-col :span="12">人数：{{detailData.people}}</a-col>
                </a-row>
                <a-table
                bordered
                :dataSource="dataSource1"
                :columns="columns1"
                :pagination="false"
                :scroll="{y:300}"
                :rowKey="record => record.item"
                >
                    <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                </a-table>
                <div class="mt16">
                    <a-row style="line-height:50px">
                        <a-col :span="12">
                            合计：
                            <span>{{dataSource1.length}} </span> &nbsp;项
                        </a-col>
                        <a-col :span="12">
                            支付方式：{{detailData.payModel}}
                        </a-col>
                    </a-row>
                    <a-row style="line-height:50px">
                        <a-col :span="12">
                            应收金额：
                            <span>{{detailData.totalPrice ? detailData.totalPrice : 0}}</span> 元
                        </a-col>
                        <a-col :span="12">
                            实收金额：
                            <span>{{detailData.realPrice ? detailData.realPrice : 0}}</span> 元
                        </a-col>
                    </a-row>
                </div>
                <div v-if="detailData.orderStatus == '已退款'">
                    <a-row style="line-height:50px">
                        <a-col :span="12">
                            订单状态：
                            <span>{{detailData.caterOrderDetailExVO.orderStatusEx}}</span> 
                        </a-col>
                        <a-col :span="12">
                            实退金额: {{detailData.caterOrderDetailExVO.refundRealPrice}}
                        </a-col>
                    </a-row>
                    <a-row style="line-height:50px">
                        <a-col :span="12">
                            退款时间：{{detailData.caterOrderDetailExVO.refundTime ? detailData.caterOrderDetailExVO.refundTime.replace('T',' ') : ''}}
                        </a-col>
                        <a-col :span="12">
                            退款操作人: {{detailData.caterOrderDetailExVO.refundPerson}}
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24"> 备注：{{detailData.caterOrderDetailExVO.des}}</a-col>
                    </a-row>
                </div>
            </a-modal>
            <a-modal :confirmLoading="confirmLoading" v-model="visibleRefund" @ok="handleOk" title="餐饮订单退款">
                <div>
                    <a-row class="mt16 mb16">
                        订单号：{{orderId}}
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="4">
                            退款金额：
                        </a-col>
                        <a-col :span="20">
                            <a-input-number :min="0" :max="maxRefundPrice" v-model="refundPrice" :precision="2" />
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="4">
                            备注：
                        </a-col>
                        <a-col :span="20">
                            <a-textarea :rows="4" v-model="reason" placeholder="请输入" ></a-textarea>
                        </a-col>
                    </a-row>
                </div>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    const columns = [
    // {
    //     title: "餐饮订单号",
    //     dataIndex: "orderId"
    // },
    {
        title: "会员手机号",
        dataIndex: "account"
    },
    {
        title: "来源",
        dataIndex: "orderPlatformStr"
    },
    // {
    //     title: "桌号",
    //     dataIndex: "deskNum"
    // },
    {
        title: "支付状态",
        dataIndex: "payStateStr"
    },
    {
        title: "支付金额",
        dataIndex: "payAmount"
    },
    {
        title: "支付方式",
        dataIndex: "payMode"
    },
    {
        title: "下单时间",
        dataIndex: "orderTime",
        scopedSlots: { customRender: "orderTime" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "payTime" }
    },
    {
        title: "退款金额",
        dataIndex: "refundAmount",
        scopedSlots: { customRender: "refundAmount" }
    },
    {
        title: "退款时间",
        dataIndex: "refundTime",
        scopedSlots: { customRender: "refundTime" }
    },
    {
        title: "购买门店",
        dataIndex: "shopName",
        scopedSlots: { customRender: "shopName" }
    },
    {
        title: "操作人",
        dataIndex: "operator"
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    const columns1 = [
    {
        title: "项",
        dataIndex: "item",
        width: 60
    },
    {
        title: "品名",
        dataIndex: "name",
        width: 220
    },
    {
        title: "数量",
        dataIndex: "number",
        width: 80
    },
    {
        title: "金额",
        dataIndex: "price",
        width: 80
    },]
    import moment from 'moment';
    export default {
        name: "mealOrder",
        components: {},
        props: {},
        data() {
            return {
                options: [],
                columns,
                dataSource: [],
                columns1,
                dataSource1: [],
                shopList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                visible: false,
                visibleRefund: false,

                detailData: {},
                refundPrice: '',
                maxRefundPrice: 0,
                reason: '',
                orderId: '',
                loading: false,
                confirmLoading: false,
                MealAmountTotal: {
                    amount: 0,
                    refundAmount: 0,
                    incomeAmount: 0,
                },
                searchLoading: false
            };
        },
        computed: {},
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            moment,
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },
            //当日餐饮订单金额统计
            getMealAmount(params) {
                this.$api.order.caterOrderTotal({
                    body: params
                }).then(res => {
                    this.MealAmountTotal = res;
                });
            },

            // 获取购票订单列表
            getList() {
                if (this.searchLoading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const orderTime = values['orderTime'] ? values['orderTime'] : []
                    values.orderStartTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.orderEndTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.payStartTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.payEndTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined
                    
                    if (values.payState && values.payState.length > 0) {
                        values.payStateStr = values.payState.join(',')
                    } else {
                        values.payStateStr = "3, 4, 5, 6";
                    }
                    delete values.payState;
                    this.getMealAmount(values)
                    this.searchLoading = true;
                    this.$api.order
                    .mealOrderSearch({
                        body: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.searchLoading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },

            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const orderTime = values['orderTime'] ? values['orderTime'] : []
                    values.orderStartTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.orderEndTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.payStartTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.payEndTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined
                    this.loading = true
                    this.$api.order
                    .mealOrderExport({
                        body: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: this.pagination.total
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false

                    }).catch(err => {
                        this.loading = false
                    })
                });
            },

            mealDetail(id) {
                this.visible = true
                this.$api.order.mealOrderDetail({
                    params: {id: id}
                })
                .then(res => {
                    this.detailData = res
                    this.dataSource1 = res.meals.list
                    this.detailData.totalPrice = res.totalPrice == '0.00' ? 0 : res.totalPrice
                    this.detailData.realPrice = res.realPrice == '0.00' ? 0 : res.realPrice
                })
            },

            mealRefund(id,maxRefundPrice) {
                this.visibleRefund = true
                this.orderId = id
                this.maxRefundPrice = maxRefundPrice
            },

            handleOk() {
                if(!this.refundPrice) {
                    this.$message.error('请输入退款金额')
                    return false
                }
                if(!this.reason) {
                    this.$message.error('请输入备注')
                    return false
                }
                this.confirmLoading = true;
                this.$api.order.mealOrderRefund({
                    body: {
                        orderId: this.orderId,
                        refundPrice: this.refundPrice,
                        reason: this.reason,
                    }
                })
                .then(res => {
                    this.visibleRefund = false
                    this.confirmLoading = false
                    this.$message.success('操作成功')
                    this.getList()
                    this.refundPrice = ''
                    this.reason = ''
                })
            }

        },
        created() {},
        mounted() {
            this.getShopList()
            this.getList()
        },
        watch: {
            '$route'(val) {
                val.name == 'mealOrder' && this.getList();
            }
        }
    };
</script>
<style lang="scss">
</style>